/**
 * Optimized logo URLs in multiple formats and sizes
 * Generated: 2026-05-07
 * Sizes: 56x56 (standard), 112x112 (retina)
 * Formats: WebP (preferred), PNG (fallback)
 */

export const LOGOS_OPTIMIZED = {
  // Standard size (56x56)
  standard: {
    webp: "https://d2xsxph8kpxj0f.cloudfront.net/310519663505843393/2RHpeR2ZmtCHr4YUeyUmbN/logo-56x56_f54718f3.webp",
    png: "https://d2xsxph8kpxj0f.cloudfront.net/310519663505843393/2RHpeR2ZmtCHr4YUeyUmbN/logo-56x56_d1457634.png",
  },
  // Retina size (112x112)
  retina: {
    webp: "https://d2xsxph8kpxj0f.cloudfront.net/310519663505843393/2RHpeR2ZmtCHr4YUeyUmbN/logo-112x112_128cb6e5.webp",
    png: "https://d2xsxph8kpxj0f.cloudfront.net/310519663505843393/2RHpeR2ZmtCHr4YUeyUmbN/logo-112x112_6c2ab19b.png",
  },
};

// Logo dimensions
export const LOGO_DIMENSIONS = {
  standard: { width: 56, height: 56 },
  retina: { width: 112, height: 112 },
};
